import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import BrandMark from './BrandMark';

const marketingLinks = [
  { to: '/try', label: 'Try Free' },
  { to: '/skill-paths', label: 'Paths' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/blog', label: 'Blog' },
];

const memberLinks = [
  { to: '/learn', label: 'Today' },
  { to: '/challenges', label: 'Challenges' },
  { to: '/skill-paths', label: 'Paths' },
  { to: '/notebook', label: 'Reflections' },
];

export default function MarketingNav() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = user ? memberLinks : marketingLinks;

  const isActive = (to: string) =>
    location.pathname === to || (to !== '/' && location.pathname.startsWith(to));

  return (
    <header className="sticky top-0 z-40 bg-warm-50/85 backdrop-blur border-b border-ink-100">
      <div className="container-app flex items-center justify-between h-16 gap-4">
        <Link to="/" aria-label="PromptGPT home" className="shrink-0">
          <BrandMark tone="dark" size={26} />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`px-3 py-2 text-sm rounded-lg transition ${
                isActive(l.to) ? 'text-ink-900 bg-warm-100' : 'text-ink-600 hover:text-ink-900'
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2 shrink-0">
          {user ? (
            <Link to="/learn" className="btn-primary text-sm">
              Open app
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn-ghost text-sm">
                Sign in
              </Link>
              <Link to="/login?mode=signup" className="btn-primary text-sm">
                Start free
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-ink-100 px-6 py-4 space-y-1 bg-warm-50">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block py-2 text-ink-700"
            >
              {l.label}
            </Link>
          ))}
          {user ? (
            <Link
              to="/learn"
              onClick={() => setOpen(false)}
              className="btn-primary w-full text-sm mt-3 justify-center"
            >
              Open app
            </Link>
          ) : (
            <div className="flex gap-2 mt-3">
              <Link to="/login" onClick={() => setOpen(false)} className="btn-secondary flex-1 text-sm justify-center">
                Sign in
              </Link>
              <Link
                to="/login?mode=signup"
                onClick={() => setOpen(false)}
                className="btn-primary flex-1 text-sm justify-center"
              >
                Start free
              </Link>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
